import { View } from '../../primitives/View';

export interface SpinnerProps {
  /**
   * Native-only — color forwarded to `ActivityIndicator`. Ignored on web,
   * where the spinner's stroke uses `border-current` to inherit from its
   * parent's text colour.
   */
  color?: string;
  /**
   * Diameter in px. Defaults to 16. The Button passes the per-size icon
   * size (`ICON_SIZE_FOR[size]`) so the spinner is the SAME size as the
   * `leftIcon` / `icon` it replaces while loading — otherwise the leading
   * visual visibly jumps (e.g. an `xl` button swaps a 20px icon for a 16px
   * spinner, shifting the label). See Button.tsx.
   */
  size?: number;
}

/**
 * In-Button spinner — web variant. An `animate-spin` ring with
 * `border-current` so the stroke inherits the surrounding text colour.
 * The `color` prop is ignored here; it's only relevant to the native
 * sibling, which renders RN's `ActivityIndicator` (no inherited colour).
 *
 * The diameter tracks the `size` prop so the spinner occupies the same box
 * as the icon it stands in for — no layout jump when `loading` toggles.
 */
export function Spinner({ size = 16 }: SpinnerProps) {
  return (
    <View
      className="animate-spin rounded-full border-2 border-current border-t-transparent"
      webProps={{ style: { width: size, height: size } }}
      accessibilityLabel="Loading"
    />
  );
}
